module.exports = __webpack_public_path__ + "img/heart_7.3d5e8ac5.png";